<!-- 模块说明 -->
<template>
  <div class="container">
    <div class="banner">
      <div class="banner-view fadeInLeft">
        <div class="view">
          <div class="title">人才配置解决方案</div>
          <div class="henxin"></div>
          <div class="text">
            基于上职家对企业和人才各自需求及信息的充分了解，依托十年来在人力资源服务领域积累的丰富人才管理经验和全国化的人才服务网络，我们致力于为客户和人才提供高质高效的人才配置解决方案，实现企业和人才的高效匹配。
          </div>
        </div>
      </div>
      <div class="decoration"></div>
    </div>
    <div class="modular modular-1">
      <div class="content">
        <div class="left">
          <div class="title">
            <div class="t1">服务项目</div>
            <div class="t2">SERVICE ITEMS</div>
            <div class="t3"></div>
          </div>
          <div
            class="typeList"
            v-for="(item, index) in projectList"
            :key="index"
            :class="{ on: projectOn == index }"
            @click="projectOn = index"
          >
            {{ item.type }}
          </div>
        </div>
        <div class="right">
          <div class="top">
            <div class="name">服务介绍</div>
            <div class="text">{{ projectList[projectOn].introduce }}</div>
          </div>
          <div class="bottom">
            <div class="name">解决方案</div>
            <div v-if="projectOn == 0 || projectOn == 3" class="programme flex">
              <div
                class="list"
                v-for="(item, index) in projectList[projectOn].programme"
                :key="index"
              >
                <div class="title">{{ item.name }}</div>
                <div v-for="(l, i) in item.list" :key="i" class="text">
                  {{ l }}
                </div>
              </div>
            </div>
            <div v-else>
              <img class="lc" :src="projectList[projectOn].programme" />
            </div>
          </div>
          <img class="jb" src="../../images/home/talent/p12.png" alt="" />
        </div>
      </div>
    </div>
    <div class="modular modular-2">
      <div class="title-on">
        <div class="t1">服务价值</div>
        <div class="t2">Service Value</div>
        <div class="t3"></div>
      </div>
      <div class="content flex">
        <div v-for="(item, index) in worthList" :key="index" class="list">
          <img :src="item.img" :alt="item.name" />
          <div class="view">
            <div class="name">{{ item.name }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modular modular-3">
      <div class="title-on">
        <div class="t1">服务优势</div>
        <div class="t2">Service advantages</div>
        <div class="t3"></div>
      </div>
      <div class="content flex">
        <div
          v-for="(item, index) in advantageList"
          :key="index"
          :class="{ on: advantageOn == index, no: advantageOn !== index }"
          @mouseenter="advantageOn = index"
          class="list"
        >
          <div class="min-view">
            <template v-if="advantageOn == index">
              <img class="back" :src="item.maxBack" :alt="item.name" />
              <div class="text-view">
                <div class="name">{{ item.name }}</div>
                <div class="text">{{ item.text }}</div>
              </div>
            </template>
            <template v-else>
              <img class="back" :src="item.minBack" :alt="item.name" />
              <div class="tips">
                <img :src="item.icon" />
                <div class="name">{{ item.name }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "人才配置|帮助企业与人才实现高效匹配-海恒科技集团",
  },
  components: {},
  data() {
    return {
      projectList: [
        {
          type: "招聘流程外包",
          introduce:
            "根据企业的具体招聘需求，提供定制的部分或全流程招聘外包解决方案，负责招聘策略制定与提升、人才寻访、人才选拔、招聘决策、入职办理、招聘渠道拓展等全流程、全渠道管理，助力企业打造人才供应链，达成业务目标。",
          programme: [
            {
              name: "目标管理",
              list: ["洞察客户需求", "人才搜寻", "设定合理目标"],
            },
            {
              name: "过程控制",
              list: [
                "拓展内外部招聘渠道",
                "完善优化招聘流程",
                "实时监控招聘进程",
              ],
            },
            {
              name: "数据管理",
              list: ["招聘项目成果分析"],
            },
            {
              name: "优化评估",
              list: ["项目实施优化建议", "客户、候选人VOC评估"],
            },
          ],
        },
        {
          type: "中高端人才访寻",
          introduce:
            "助力企业搜寻中高层、招募精英，同时助力人才获取更优质岗位，实现双向匹配。服务覆盖各行各业，解决高精尖人才稀缺难吸引、新业务领域需求难交付等问题。",
          programme: require("../../images/home/talent/p17.png"),
        },
        {
          type: "产教融合",
          introduce:
            "为了满足客户的用工需求，在上游，上职家布局职业人才培养、教育，开启“产业+专业”的产教融合新模 式，推动企业与职业教育相结合，打破供需不匹配问题，帮助企业形成完善的人才培养机制和供应链体系，为毕业生提供精准及高端就业。 ",
          programme: require("../../images/home/talent/p18.png"),
        },
        {
          type: "咨询培训",
          introduce:
            "围绕组织及人才发展的全生命周期，结合人才和组织实际情况，立足自身管理经验、专业顾问、线上系统 等，为客户提供个性化的咨询培训解决方案，提供包括人才发展咨询与培训、业务赋能等服务，帮助客户实现激活组织、赋能企业人才发展、业务改善。",
          programme: [
            {
              name: "组织管理咨询",
              list: [
                "组织诊断、组织体系设计、薪酬体系设计、绩效体系设计、人力资源规划、市场薪酬调研、组织文化咨询、中小企业人力资源制座体系搭建等。",
              ],
            },
            {
              name: "人才发展咨询与培训",
              list: [
                "人才发展规划、内部人才盘点、任职资格体系设计、内外部人才选拔、各层级人才培训、技能培训、创业培训等。",
              ],
            },
            {
              name: "业务赋能",
              list: [
                "业务诊断及业绩改善、业务流程优化、业务经验萃取、业务骨干赋能等。",
              ],
            },
          ],
        },
      ],
      projectOn: 0,
      worthList: [
        {
          name: "降低成本",
          img: require("../../images/home/talent/p4.png"),
          text: "降低企业和人才在招聘过程中的显性和隐性成本，通过精准匹配人才和职位，可为企业降低因招聘不适合的人才而导致的培训和流失成本",
        },
        {
          name: "增加效率",
          img: require("../../images/home/talent/p13.png"),
          text: "人岗匹配，人才更好地应用新技术和新思想，促进企业的发展；人才只有在合适的岗位上，才能充分发挥其潜能，为企业创造更多的利益",
        },
        {
          name: "提升价值",
          img: require("../../images/home/talent/p9.png"),
          text: "促进企业人才资源配置与管理价值的有效提升",
        },
        {
          name: "降低人才流动率",
          img: require("../../images/home/talent/p5.png"),
          text: "人才配置方案能够提高员工的工作积极性，提高员工创造价值的能力。同时，有助于帮助员工找到自己的价值，增强员工对企业的归属感",
        },
      ],
      advantageList: [
        {
          name: "经验丰富",
          icon: require("../../images/home/talent/p16.png"),
          minBack: require("../../images/home/talent/p6.png"),
          maxBack: require("../../images/home/talent/p7.png"),
          text: "丰富的大型项目管理经验，已作为大型国有企业、制造业企业、互联网企业人才输送的重要选择。",
        },
        {
          name: "多渠道服务",
          icon: require("../../images/home/talent/p14.png"),
          minBack: require("../../images/home/talent/p2.png"),
          maxBack: require("../../images/home/talent/p3.png"),
          text: "利用广泛的宣传渠道及招聘渠道，支持包括自身渠道、第三方渠道、内部推荐、网络、主动应聘、产教融合等在内的多渠道管理，为企业提供丰富多样的定制化招聘及测评服务，赋能各行业各领域企业客户人才发展全生命周期的规划与发展。",
        },
        {
          name: "团队专业",
          icon: require("../../images/home/talent/p15.png"),
          minBack: require("../../images/home/talent/p10.png"),
          maxBack: require("../../images/home/talent/p11.png"),
          text: "高素质的执行团队由拥有全岗位、批量招聘经验的招聘顾问+专业的咨询培训顾问组成，顾问们具备全国操作的把控能力，强有力的执行能力，可快速精准掌握客户需求，解决客户痛点和难点。",
        },
      ],
      advantageOn: 0,
    };
  },
  watch: {},
  created() {},
  methods: {},
  computed: {},
};
</script>
<style lang="less" scoped>
.modular-3 {
  margin-bottom: 70px;
  .list {
    .min-view {
      .text-view {
        .text {
          font-size: 18px;
          width: 269px;
          color: #333333;
          line-height: 30px;
        }
        .name {
          margin-bottom: 25px;
        }
        position: absolute;
        top: 49px;
        left: 40px;
        opacity: 0;
      }
      .tips {
        img {
          width: 60px;
          height: 60px;
          display: block;
          margin: 165px auto 20px;
        }
        text-align: center;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
      }
      .back {
        width: 100%;
        height: 100%;
      }
      width: 282px;
      height: 440px;
      position: relative;
    }
    .name {
      font-size: 24px;
      color: #333333;
      font-weight: bold;
    }
    overflow: hidden;
    border-radius: 6px;
    box-shadow: -1px 0px 9.2px 0.08px rgba(0, 0, 0, 0.1);
  }
  .no {
    .min-view {
      animation: fadeInMin 1000ms both;
    }
    @keyframes fadeInMin {
      from {
        width: 588px;
      }

      to {
        width: 282px;
      }
    }
  }
  .on {
    .text-view {
      animation: fadeInLeft 1000ms both;
    }
    .min-view {
      animation: fadeInWidth 1000ms both;
    }
    @keyframes fadeInWidth {
      from {
        width: 282px;
      }

      to {
        width: 588px;
      }
    }
  }
}
.modular-2 {
  .list:hover {
    .view {
      .name {
        font-size: 24px;
      }
      top: 0;
      text-align: left;
      transition: all 1s;
    }
  }
  .list {
    .view {
      .text {
        font-size: 14px;
        line-height: 25px;
      }
      .name {
        font-size: 20px;
        margin-bottom: 20px;
      }
      text-align: center;
      color: white;
      padding: 20px 29px;
      width: 80%;
      height: 100%;
      position: absolute;
      top: 81%;
      left: 0;
      background: rgba(12, 127, 229, 0.8);
    }
    img {
      width: 100%;
      height: 100%;
    }
    width: 282px;
    height: 340px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
  }
}
.modular-1 {
  .content {
    .right {
      .bottom {
        .lc {
          width: 750px;
          height: 147px;
        }
        .programme {
          .text {
            max-width: 224px;
            font-size: 16px;
            color: #666666;
            margin-top: 12px;
          }
          .title {
            font-size: 18px;
            color: #166dba;
            font-weight: bold;
            margin-bottom: 15px;
          }
          align-items: flex-start;
        }
        .name {
          margin-bottom: 40px;
        }
        width: 752px;
        margin: auto;
      }
      .top {
        .text {
          font-size: 16px;
          color: #666666;
        }
        width: 752px;
        padding: 27px 0;
        margin: 24px auto 55px;
        border-bottom: 1px solid #eeeeee;
      }
      .name {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 15px;
      }
      width: 970px;
      height: 500px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 6px;
      box-shadow: -1px 0px 9.2px 0.08px rgba(0, 0, 0, 0.07);
      position: absolute;
      top: 50px;
      right: 0;
      .jb {
        width: 100px;
        height: 155px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .left {
      .on {
        border-left: 6px solid #0c7fe5;
        box-shadow: -1px 0px 9.2px 0.08px rgba(5, 67, 123, 0.22);
        color: #166dba !important;
        font-weight: bold;
      }
      .typeList:hover {
        color: #166dba !important;
      }
      .typeList {
        font-size: 20px;
        color: #333333;
        padding: 26px 0;
        padding-left: 52px;
        cursor: pointer;
      }
      .title {
        .t3 {
          width: 30px;
          height: 4px;
          background: #cae6ff;
          margin-left: 51px;
        }
        .t2 {
          font-size: 16px;
          color: #dddddd;
          margin: 10px 51px 15px;
        }
        .t1 {
          font-size: 24px;
          color: #333333;
          font-weight: bold;
          margin: 49px 51px 0;
        }
        text-align: left;
        margin-bottom: 32px;
      }
      width: 300px;
      height: 600px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 6px;
      box-shadow: -1px 0px 9.2px 0.08px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
    }
    position: absolute;
    top: -190px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  height: 460px;
  background: url(../../images/home/talent/p1.png) no-repeat;
  background-size: cover;
  margin-top: 290px;
  position: relative;
}
.modular {
  .title-on {
    .t3 {
      width: 30px;
      height: 4px;
      background: #cae6ff;
      margin: auto;
    }
    .t2 {
      font-size: 16px;
      color: #dddddd;
      margin: 10px 0 15px;
    }
    .t1 {
      font-size: 24px;
      color: #333333;
      font-weight: bold;
    }
    text-align: center;
    margin-bottom: 40px;
  }
  padding: 50px 0;
  width: 100%;
  background-position: center center;
}
.banner {
  .view {
    .text {
      font-size: 16px;
      line-height: 27px;
      width: 576px;
    }
    .henxin {
      width: 70px;
      height: 1px;
      background: rgba(255, 255, 255, 0.8);
      margin: 20px 0;
    }
    .title {
      font-size: 30px;
      font-weight: 500;
    }
    width: 580px;
    color: #ffffff;
    float: right;
  }
  .banner-view {
    position: absolute;
    width: 48%;
    top: 75px;
    left: 0;
    background: rgba(0, 0, 0, 0.1);
    padding: 31px 19px;
  }
  .decoration {
    width: 582px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 102%;
    z-index: 10;
    background: url(../../images/home/programme/diao.png) no-repeat;
    background-size: cover;
  }
  width: 100%;
  height: 460px;
  background: url(../../images/home/talent/p8.png) no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
}
.content {
  width: 1200px;
  margin: auto;
}
.container {
  overflow: hidden;
  width: 100%;
}
</style>
